import DrawerManager from '@/components/common/DrawerManager';
import ModalFromUrlQueryManager from '@/components/ModalFromUrlQueryManager';
import ModalManager from '@/components/ModalManager';
import client from '@/services/graphql/client';
import { usePushEventPoller } from '@common/react/usePushEventPoller';
import { VersionChecker } from './common/VersionChecker';

// Common providers every authed page will need.
// NOTE: If a given page uses modals/drawers that rely on page-specific
// providers, ensure those providers are included higher up the component
// hierarchy than these.
export const AuthedPageProviders = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    usePushEventPoller(client);

    return (
        <ModalManager.Provider>
            <DrawerManager>
                <VersionChecker>
                    <ModalFromUrlQueryManager>
                        {children}
                    </ModalFromUrlQueryManager>
                </VersionChecker>
            </DrawerManager>
        </ModalManager.Provider>
    );
};
